// ─────────────────────────────────────────────
//  sheetAicMarker — does this campus mark the day's AIC by CELL FORMATTING?
//
//  Tampa names no AIC in the grid: their DOD is whichever attending is printed
//  BOLD/coloured in the attending column, so the import reads cell formatting
//  (detectDodCode) to find them. Wesley Chapel and Carrollwood name theirs in
//  the sheet text instead.
//
//  That convention used to be a literal `fid === "tampa"` in the Cloud
//  Function. Same shape as the room-family hardcode (blocker #4): a new
//  hospital whose campuses are mercy-main/mercy-north could never get
//  formatting-based AIC detection without a code change, and — worse — nothing
//  told them it existed.
//
//  Resolution order mirrors roomFamilyForFacility:
//    1. the facility doc's CONFIGURED flag (facility.sheetAic.fromFormatting),
//       so a tenant opts in or out without a redeploy;
//    2. the built-in map (unchanged behaviour for the known campuses);
//    3. false.
//
//  FAILS CLOSED at step 3. Reading bold/colour on a campus that does not use
//  that convention would crown whichever attending happened to be styled —
//  a confidently wrong AIC is worse than none, because the board looks correct.
//
//  Pure — no Firebase.
// ─────────────────────────────────────────────

// Campuses whose sheet marks the AIC/DOD by formatting rather than by name.
export const AIC_FROM_FORMATTING_BY_FACILITY = {
  tampa: true,
};

/**
 * @param {string} facilityId
 * @param {object} [opts]
 *   @param {Object<string,object>} [opts.configByFacility] — { fid: facilityDoc }
 * @returns {boolean}
 */
export function usesFormattingAic(facilityId, opts = {}) {
  const configByFacility = (opts && opts.configByFacility) || {};
  const stored = configByFacility[facilityId]?.sheetAic?.fromFormatting;
  // Only an explicit boolean overrides. A half-written config ({} or a string)
  // must not silently disable a campus that works today.
  if (typeof stored === "boolean") return stored;
  return AIC_FROM_FORMATTING_BY_FACILITY[facilityId] === true;
}
